import React from 'react';
import { getConfig } from '@alfa-bank/newclick-core/utils';

import { TitleDesktop } from '@alfalab/core-components/typography';

import { Step } from '../../../shared/components/step';
import { getLandingImagePath } from '../../../shared/utils';
import { DESKTOP_STEPS } from '../../constants/steps';

import styles from './index.module.css';

export const Steps = () => {
    const { staticBaseUrl, altDomain } = getConfig();

    return (
        <section aria-labelledby='steps-heading' data-test-id='steps'>
            <TitleDesktop
                id='steps-heading'
                className={styles.title}
                tag='h2'
                font='system'
                weight='bold'
                view='large'
            >
                Как настроить
            </TitleDesktop>

            <div className={styles.steps} role='list' data-test-id='steps-list'>
                {DESKTOP_STEPS.map(({ imgSrc, ...step }, index) => {
                    const stepNumber = index + 1;
                    const img = `${staticBaseUrl}${getLandingImagePath(imgSrc, Boolean(altDomain))}`;

                    return (
                        <Step
                            key={step.title}
                            imgSrc={img}
                            index={stepNumber}
                            typographyVariant='desktop'
                            {...step}
                        />
                    );
                })}
            </div>
        </section>
    );
};
